import { render } from "./ColetarAssinaturaResponsavel.vue?vue&type=template&id=5048f37b&scoped=true"
import script from "./ColetarAssinaturaResponsavel.vue?vue&type=script&lang=js"
export * from "./ColetarAssinaturaResponsavel.vue?vue&type=script&lang=js"

import "./ColetarAssinaturaResponsavel.vue?vue&type=style&index=0&id=5048f37b&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5048f37b"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QInput,QImg,QTooltip,QBtn});
